import { Typography } from 'antd';
import './CardComponent.scss';
const {Title} =  Typography;

interface CardComponentProps {
  title: string;
  value: string;
}

const CardComponent = ({ title, value }: CardComponentProps) => {
  return (
    <div className="CardComponent">
      <Title level={5} className={"CardComponent__title"}>{title}</Title>
      <Title level={2} className={"CardComponent__value"}>{value}</Title>
    </div>
  );
};

export default CardComponent;